// Q6 (ADR-074, B8): a stored character name is shown without the placeholder the builder used to
// generate before B8 ("High Elf Ranger lvl 1 STR15 DEX12 …", or "Personaggio senza nome" when
// empty). Display only: rows keep what they store (Q6 ruled no data write). The pattern is that
// generator's own output, a legacy-data shim, not a game rule.
// ponytail: regex on the legacy format; drop it once no stored name carries that format.
const LEGACY_TAIL = /(?:\s+lvl \d+)?(?:\s*\b[A-Z]{3}\d+\b)+\s*$|\s+lvl \d+\s*$/
const LEGACY_EMPTY = 'Personaggio senza nome'

export const UNNAMED_CHARACTER = 'Unnamed character'

export function displayCharacterName(name: string | null | undefined): string {
  const trimmed = (name ?? '').trim()
  if (trimmed === LEGACY_EMPTY) return UNNAMED_CHARACTER
  return trimmed.replace(LEGACY_TAIL, '').trim() || UNNAMED_CHARACTER
}
